/**
 * Styled Components - Created by eduardoquintero on 19/09/19.
 */
import styled from 'styled-components'
import { GRAY_DARK } from '../../../theme/colors'

interface DivProps {
  selected?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`

export const Text = styled.div`
  color: ${GRAY_DARK};
  font-size: 10px;
  line-height: 19px;
  margin-top: 4px;
  text-align: center;
`
export const Icon = styled.img`
  max-height: 24px;
  height: 100%;
  object-fit: contain;
  ${({ selected }: DivProps) => selected ? `
    filter: drop-shadow(0px 0px 1px lightgrey);
  ` : ''}
`
export const MembersCountContainer = styled.div`
  position: absolute;
  right: -1px;
  top: -4px;
`

export const MembersCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${GRAY_DARK};
  border-radius: 50%;
  width: 15px;
  height: 15px;
  font-size: 8px;
  font-weight: 600;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignApproval/Tab/styledComponents.tsx